import { useQuery } from "react-query";
import { getRolesPermissions } from "../../../../../actions/Utilities/RolePermission";

export const useGetRolePermissions = (roleId, enableGet) => {
  return useQuery(
    ["RoleActivePermissions", roleId],
    () => getRolesPermissions(roleId),
    {
      enabled: enableGet,
      refetchOnWindowFocus: false,
    }
  );
};
